import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { IconWithText } from 'Components';

class UploadExcel extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.showFileUpload = this.showFileUpload.bind(this);
  }

  showFileUpload() {
    this.ref.current.click();
  }

  render() {
    return (
      <Fragment>
        <IconWithText
          onClick={this.showFileUpload}
          icon="publish"
          text={i18n.t('common:Upload Excel')}
          textOrientation="after"
          {...this.props}
        />
        <input
          type="file"
          ref={this.ref}
          accept=".xls,.xlsx,.csv"
          style={{ display: 'none' }}
          onChange={this.props.onChange}
        />
      </Fragment>
    );
  }
}

UploadExcel.propTypes = {
  showFileUpload: PropTypes.func,
  onChange: PropTypes.func,
};

export default UploadExcel;



// WEBPACK FOOTER //
// ./src/components/Actions/UploadExcel/UploadExcel.jsx